module.exports = __webpack_public_path__ + "img/202627_a_de.a359a8cf.png";